import { useEffect } from 'react';

const buildValue = (node, value, pipe) => {
  const selectionStart = (node === null || node === void 0 ? void 0 : node.selectionStart) || 0;

  if (!value) {
    return [value, selectionStart];
  }

  const pipeValue = pipe && pipe(value, selectionStart);

  if (Object.prototype.hasOwnProperty.call(pipeValue, 'value')) {
    const {
      value,
      cursorPosition
    } = pipeValue;
    return [value, cursorPosition];
  } else {
    return [pipeValue, selectionStart];
  }
};

export const usePipe = ({
  pipe,
  value,
  ref
}) => {
  if (!pipe) {
    return value;
  }

  const [valueNew, cursorPosition] = buildValue(ref, value, pipe);
  useEffect(() => {
    if (value !== valueNew && !!ref) {
      ref.setSelectionRange(cursorPosition, cursorPosition);
    }
  }, [valueNew, cursorPosition, value, ref]);
  return valueNew;
};